import { CredentialType, IdentifierType } from '@/api/types';

export enum UIFlow {
  SignIn = 'SignIn',
  Email = 'Email',
  StepUp = 'StepUp',
  SignInStepUp = 'SignInStepUp',
  PasswordResetStepUp = 'PasswordResetStepUp',
  PasswordResetPending = 'PasswordResetPending',
  PasswordResetLinkExpired = 'PasswordResetLinkExpired',
  PasswordResetLinkAlreadyUsed = 'PasswordResetLinkAlreadyUsed',
}

export type ClientAuthenticationSession = {
  id: string;
  originalSessionId: string;
  clientId: string;
  allowedIdentifiers: IdentifierType[];
  locale?: string;
  partner: string;
  originalRequestUrl: string;
  campaignId?: string;
  interactionId?: string;
  origin?: string;
  passcodeExpiryMinutes: number;
  asurionSessionId: string;
  userBrowserId?: string;
  uiFlow: UIFlow;
  allowedCredentials: CredentialType[];
  mobileApp: boolean;
  disabledCookies?: string[];
};

export const defaultPartner = 'default';

export const defaultSessionCookie: ClientAuthenticationSession = {
  allowedCredentials: [CredentialType.EMAIL_OTP, CredentialType.PASSWORD],
  allowedIdentifiers: [IdentifierType.EMAIL],
  asurionSessionId: '',
  clientId: '',
  id: '',
  mobileApp: false,
  originalRequestUrl: '',
  originalSessionId: '',
  partner: defaultPartner,
  passcodeExpiryMinutes: 30,
  uiFlow: UIFlow.SignIn,
};
